
import React, { useEffect, useState } from 'react';
import { getDocumentsTable, getDocumentsDetails, deleteDocumentsDetails } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import '../../../Utility/pagination.css'
import { EditDocumentDetails } from './form';
import { Deletemodel, Pagination } from '../../Common/Functions'

const Documents_Details  = () => {

        const [documentTable, setDocumentTable] = useState([]);
        const [documentDetails, setdocumentDetails] = useState([]);
        const [formData, setFormData] = useState({ subcategory: '', category_id: '', status: '' });
        const [showModal, setShowModal] = useState(false);
        const [selectedDocumentDetails, setSelectedDocumentDetails] = useState(null);
        const [showAddModal, setShowAddModal] = useState(false);
        const [showEditModal, setShowEditModal] = useState(false);
        const [addoredit, setaddoredit] = useState()
        const [deleteID, setDeleteID] = useState("");
        const [deletemodel, showDeletemodel] = useState(false)
        const [totalPages, setTotalPages] = useState(0);
        const [currentPage, setCurrentPage] = useState(1);
        const rolesPerPage = 10; // Number of roles per page

        useEffect(() => {
            fetchDocumentTable();
            fetchDocumentsDetails();

        }, []);

        const handledeletemodel = (id) => {
            showDeletemodel(true);
            setDeleteID(id);
        }


        const fetchDocumentsDetails = async (page = 1, text = "") => {
            try {
                const response = await getDocumentsDetails(page, text);
                console.log(response);

                if (response.data && response.data.data) {
                    setdocumentDetails(response.data.data);
                    setTotalPages(response.data.pagination.total_pages); // Update total pages for pagination

                }
            } catch (error) {
                console.error('Error fetching document d details data:', error);
            }
        };

        const fetchDocumentTable = async () => {
            try {
                const response = await getDocumentsTable();
                if (response.data && response.data.data) {
                    setDocumentTable(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching document type data:', error);
            }
        };






        const openAddModal = () => {
            setaddoredit(true)
            setShowEditModal(!showEditModal)
        }
        const openEditModal = (cat) => {
            setSelectedDocumentDetails(cat);
            setaddoredit(false)
            setShowEditModal(!showEditModal)
        }

        // Handle form input changes
        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({
                ...formData,
                [name]: value,
            });
        };


        // Delete a category
        const handleDelete = async () => {
            try {
                await deleteDocumentsDetails(deleteID);
                toast.success('Documents Details deleted successfully');
                fetchDocumentsDetails();
                showDeletemodel(false);
            } catch (error) {
                console.error('Error deleting Documents Details:', error);
                toast.error('Error deleting Documents Details');
            }
        };

        // Pagination logic
        const handlePageChange = (pageNumber) => {
            if (pageNumber < 1 || pageNumber > totalPages) return;
            setCurrentPage(pageNumber);
            fetchDocumentTable(pageNumber);
            fetchDocumentsDetails(pageNumber);


        };



        const handleSearch = async (text) => {
            fetchDocumentTable(1, text);
        }

        return (
            <div className="page-wrappers">
                <div className="page-content">
                    <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>Documents Details List</h6>
                    <hr />
                    <button
                        type="button"
                        onClick={() => openAddModal()}
                        className="btn btn-primary mb-2" style={{ fontFamily: "poppins" }}
                    >
                        Add Documents Details
                    </button>

                    <div className="card">
                        <div className="card-body">
                            <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                                <div className="d-flex position-relative" style={{ width: "100%" }}>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search..."
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                    <img
                                        src="/assets/images/icons/search.png"
                                        alt="Search Icon"
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            height: "18px",
                                            pointerEvents: "none",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table
                                    id="example"
                                    className="table table-striped  table-sm table-bordered"
                                    style={{ width: "100%", fontFamily: "poppins" }}
                                >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Document Url</th>

                                            <th>Document Table</th>
                                            <th>Issue Date</th>
                                            <th>Expiry Date</th>
                                            <th>date</th>
                                            <th>created_by_id</th>
                                            {/* <th>Status</th> */}
                                            {/* <th>CD</th>
                                        <th>UD</th> */}
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {documentDetails.map((subcat, index) => (
                                            <tr key={subcat.document_details_id}>
                                                <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                                <td>{subcat.document_url}</td>
                                                <td>{subcat.documents_table_title}</td>
                                                <td>{subcat.issued_date}</td>
                                                <td>{subcat.expiry_date}</td>
                                                <td>{subcat.date}</td>
                                                <td>{subcat.created_by_id}</td>
                                                {/* <td>{subcat.status}</td> */}
                                                <td>
                                                    <img src='/assets/images/icons/edit.png' onClick={() => openEditModal(subcat)} height={"16px"} />
                                                    <img src='/assets/images/icons/delete.png' className="mx-1" onClick={() => handledeletemodel(subcat.document_details_id)} height={"16px"} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <Pagination 
        currentPage={currentPage} 
        totalPages={totalPages} 
        onPageChange={handlePageChange} 
      />
                            </div>
                        </div>
                    </div>
                </div>
                {deletemodel && (
                    <Deletemodel
                        setShowModal={showDeletemodel}
                        handleDelete={handleDelete}
                    />
                )}




                {/* <EditDocumentDetails
                    showModal={showEditModal}
                    setShowModal={setShowEditModal}
                    fetchDocumentDetails={fetchDocumentsDetails}
                    selectedDocumentDetails={selectedDocumentDetails}
                    AddorEdit={addoredit}
                /> */}
                <EditDocumentDetails showModal={showEditModal} setShowModal={setShowEditModal} fetchDocumentDetails={fetchDocumentsDetails} selectedDocumentDetails={selectedDocumentDetails} setselectedDocumentDetails={() => setSelectedDocumentDetails()}
                    AddorEdit={addoredit} />
            </div>
        )
    }

export default Documents_Details